import { z } from 'zod';
import { hexQuantitySchema } from './common.js';
/** Starknet `block_id` accepted by every read RPC. */
export const starknetBlockIdSchema = z.union([
    z.literal('latest'),
    z.literal('pending'),
    z.object({ block_number: z.number().int().nonnegative() }).strict(),
    z.object({ block_hash: hexQuantitySchema }).strict(),
]);
